import withQuery from 'with-query';

const request = ({ url, method, body }) => {
  if (method === 'GET') {
    return fetch(withQuery(url, body), {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json();
    });
  }
  return fetch(url, {
    credentials: 'include',
    method,
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  }).then((response) => {
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    return response.json();
  });
};

const asyncFn = ({
  body, url, model, name, method, type, extra,
}) => async (dispatch) => {
  const payload = {};

  dispatch({
    type: model.request,
    payload,
    name,
    extra,
  });
  try {
    const response = await request({ url, method: method || 'POST', body });
    // console.log(!response.data && response.error, response);
    if (!response.data && response.error) throw new Error(response.error);

    if (type) {
      console.log("type is active");
    }

    dispatch({
      type: model.response,
      payload: response.data,
      name,
      extra,
    });
    return response;
  } catch (error) {
    if (error.message === 'user_not_logged') {
      dispatch({
        type: 'RESPONSE_LOGOUT',
      });
    } else {
      dispatch({
        type: model.error,
        message: error.message,
        name,
        extra,
      });
    }
    return error;
  }
};

export { request, asyncFn };



// WEBPACK FOOTER //
// ./src/models/utils.js